import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Key",
  "use": "icon-Key-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol viewBox=\"0 0 24 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Key\">\n<rect width=\"24\" height=\"18\" rx=\"2\" fill=\"#444444\" />\n<path d=\"M7.5 5.7395L11.1885 5.2315V8.795H7.5V5.74V5.7395ZM7.5 12.2605L11.1885 12.769V9.249H7.5V12.2605ZM11.594 12.823L16.5 13.5V9.249H11.594V12.823ZM11.594 5.177V8.795H16.5V4.5L11.594 5.177Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol